// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoCard-module__font-s-10___IE2pT {
  font-size: 10px !important;
}

.InfoCard-module__font-s-12___UChaW {
  font-size: 12px !important;
}

.InfoCard-module__font-s-13___IdVlQ {
  font-size: 13px !important;
}

.InfoCard-module__font-s-14___jdVUT {
  font-size: 14px !important;
}

.InfoCard-module__font-s-15___dHQZq {
  font-size: 15px !important;
}

.InfoCard-module__font-s-16___IPMN5 {
  font-size: 16px !important;
}

.InfoCard-module__font-s-18___eF2N7 {
  font-size: 18px !important;
}

.InfoCard-module__font-s-20___WGp7d {
  font-size: 20px !important;
}

.InfoCard-module__font-s-22___Kfdqo {
  font-size: 22px !important;
}

.InfoCard-module__font-s-28___n2kkT {
  font-size: 28px !important;
}

.InfoCard-module__font-w-400___D53Z6 {
  font-weight: 400 !important;
}

.InfoCard-module__font-w-500___RJPkg {
  font-weight: 500 !important;
}

.InfoCard-module__font-w-600___GauWv {
  font-weight: 600 !important;
}

.InfoCard-module__font-w-700___iWSez {
  font-weight: 700 !important;
}

.InfoCard-module__p-5___hLebZ {
  padding: 5px !important;
}

.InfoCard-module__p-12___BHsqd {
  padding: 12px !important;
}

.InfoCard-module__p-16___IcNvH {
  padding: 16px !important;
}

.InfoCard-module__p-30____W9Ym {
  padding: 30px !important;
}

.InfoCard-module__p-b-0___m9vgz {
  padding-bottom: 0 !important;
}

.InfoCard-module__p-b-5___dRORK {
  padding-bottom: 5px !important;
}

.InfoCard-module__p-b-10___kdQm6 {
  padding-bottom: 10px !important;
}

.InfoCard-module__p-b-12___a20bZ {
  padding-bottom: 12px !important;
}

.InfoCard-module__p-b-16___eqp8K {
  padding-bottom: 16px !important;
}

.InfoCard-module__p-b-18___Tc78I {
  padding-bottom: 18px !important;
}

.InfoCard-module__p-b-20___l1iSf {
  padding-bottom: 20px !important;
}

.InfoCard-module__p-b-25___WAxYL {
  padding-bottom: 25px !important;
}

.InfoCard-module__p-b-30___SkVpa {
  padding-bottom: 30px !important;
}

.InfoCard-module__p-b-50___WJaUX {
  padding-bottom: 50px !important;
}

.InfoCard-module__p-t-0___RoP6b {
  padding-top: 0 !important;
}

.InfoCard-module__p-t-12___rIesp {
  padding-top: 12px !important;
}

.InfoCard-module__p-t-16___BJzN2 {
  padding-top: 16px !important;
}

.InfoCard-module__p-t-18___yjLuU {
  padding-top: 18px !important;
}

.InfoCard-module__p-t-20___pflb5 {
  padding-top: 20px !important;
}

.InfoCard-module__p-t-30___FiiBp {
  padding-top: 30px !important;
}

.InfoCard-module__p-t-40___nidgQ {
  padding-top: 40px !important;
}

.InfoCard-module__p-t-50___i7LMD {
  padding-top: 50px !important;
}

.InfoCard-module__p-l-20___A4ySy {
  padding-left: 20px !important;
}

.InfoCard-module__p-l-30___bJUI6 {
  padding-left: 30px !important;
}

.InfoCard-module__p-l-40___rlXdI {
  padding-left: 40px !important;
}

.InfoCard-module__p-r-16___v6CZm {
  padding-right: 16px !important;
}

.InfoCard-module__p-r-20___rqS4J {
  padding-right: 20px !important;
}

.InfoCard-module__p-r-30___OoXr8 {
  padding-right: 30px !important;
}

.InfoCard-module__p-r-50___ukmf2 {
  padding-right: 50px !important;
}

.InfoCard-module__p-r-60___FGw32 {
  padding-right: 60px !important;
}

.InfoCard-module__m-b-1___nvVGt {
  margin-bottom: 1px !important;
}

.InfoCard-module__m-b-2___UzLQO {
  margin-bottom: 2px !important;
}

.InfoCard-module__m-b-6___YgEE8 {
  margin-bottom: 6px !important;
}

.InfoCard-module__m-b-8___W2mjM {
  margin-bottom: 8px !important;
}

.InfoCard-module__m-b-10___Xy1QJ {
  margin-bottom: 10px !important;
}

.InfoCard-module__m-b-14___nuprn {
  margin-bottom: 14px !important;
}

.InfoCard-module__m-b-16___CYxXt {
  margin-bottom: 16px !important;
}

.InfoCard-module__m-b-20___adgeR {
  margin-bottom: 20px !important;
}

.InfoCard-module__m-b-22___hS1J5 {
  margin-bottom: 22px !important;
}

.InfoCard-module__m-b-24___rHMuM {
  margin-bottom: 24px !important;
}

.InfoCard-module__m-b-30___hAjev {
  margin-bottom: 30px !important;
}

.InfoCard-module__m-b-32___Wk28N {
  margin-bottom: 32px !important;
}

.InfoCard-module__m-b-40___uTHku {
  margin-bottom: 40px !important;
}

.InfoCard-module__m-t-2___Uzsv3 {
  margin-top: 2px !important;
}

.InfoCard-module__m-t-3___iPmeP {
  margin-top: 3px !important;
}

.InfoCard-module__m-t-4___dF2pX {
  margin-top: 4px !important;
}

.InfoCard-module__m-t-5___VcWaw {
  margin-top: 5px !important;
}

.InfoCard-module__m-t-8___XmW1D {
  margin-top: 8px !important;
}

.InfoCard-module__m-t-10___mI0wd {
  margin-top: 10px !important;
}

.InfoCard-module__m-t-15___G7810 {
  margin-top: 15px !important;
}

.InfoCard-module__m-t-16___KM8f_ {
  margin-top: 16px !important;
}

.InfoCard-module__m-t-20___KZQ7I {
  margin-top: 20px !important;
}

.InfoCard-module__m-t-22___IqKPt {
  margin-top: 22px !important;
}

.InfoCard-module__m-t-30___yfEl8 {
  margin-top: 30px !important;
}

.InfoCard-module__m-t-32___pvCSu {
  margin-top: 32px !important;
}

.InfoCard-module__m-l-auto___hEPay {
  margin-left: auto !important;
}

.InfoCard-module__m-l-4___cqBYF {
  margin-left: 4px !important;
}

.InfoCard-module__m-l-5___hHoXh {
  margin-left: 5px !important;
}

.InfoCard-module__m-l-6___h0NMV {
  margin-left: 6px !important;
}

.InfoCard-module__m-l-8___mq7HD {
  margin-left: 8px !important;
}

.InfoCard-module__m-l-10___qtA97 {
  margin-left: 10px !important;
}

.InfoCard-module__m-l-16___iylwY {
  margin-left: 16px !important;
}

.InfoCard-module__m-l-20___q4yT8 {
  margin-left: 20px !important;
}

.InfoCard-module__m-l-24___YgQbr {
  margin-left: 24px !important;
}

.InfoCard-module__m-l-30___NI5jV {
  margin-left: 30px !important;
}

.InfoCard-module__m-l-35___HYo8c {
  margin-left: 35px !important;
}

.InfoCard-module__m-l-40___RKQBL {
  margin-left: 40px !important;
}

.InfoCard-module__m-r-8___Qxspx {
  margin-right: 8px !important;
}

.InfoCard-module__m-r-10___M824N {
  margin-right: 10px !important;
}

.InfoCard-module__m-r-16___Z8zLw {
  margin-right: 16px !important;
}

.InfoCard-module__m-r-20___kJJx_ {
  margin-right: 20px !important;
}

.InfoCard-module__m-r-24___nFr1S {
  margin-right: 24px !important;
}

.InfoCard-module__m-r-30___LK9x3 {
  margin-right: 30px !important;
}

.InfoCard-module__m-r-40___bZaUC {
  margin-right: 40px !important;
}

.InfoCard-module__border-r-3___GJtg3 {
  border-radius: 3px !important;
}

.InfoCard-module__border-r-4___wvowk {
  border-radius: 4px !important;
}

.InfoCard-module__border-r-6___Yfa0a {
  border-radius: 6px !important;
}

.InfoCard-module__border-r-10___HZ9Kv {
  border-radius: 10px !important;
}

.InfoCard-module__border-r-12___VHwqe {
  border-radius: 12px !important;
}

.InfoCard-module__border-r-16___LkFnc {
  border-radius: 16px !important;
}

.InfoCard-module__border-r-50___lDtQu {
  border-radius: 50% !important;
}

.InfoCard-module__primary-border___ru61z {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.InfoCard-module__primary-border-b___UEa7e {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.InfoCard-module__primary-border-t___RCnI6 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.InfoCard-module__primary-border-l___Y9xMX {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.InfoCard-module__primary-border-r___KdZfj {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.InfoCard-module__secondary-border___AayhP {
  border: 1px solid #637768;
}

.InfoCard-module__secondary-border-b___fMkEj {
  border-bottom: 1px solid #637768;
}

.InfoCard-module__secondary-border-t___nFnwY {
  border-top: 1px solid #637768;
}

.InfoCard-module__secondary-border-l___Y_deX {
  border-left: 1px solid #637768;
}

.InfoCard-module__secondary-border-r___JO99N {
  border-right: 1px solid #637768;
}

.InfoCard-module__gap-0___F0i9N {
  gap: 0 !important;
}

.InfoCard-module__gap-2___VhWNx {
  gap: 2px !important;
}

.InfoCard-module__gap-4____oMFe {
  gap: 4px !important;
}

.InfoCard-module__gap-5___KuMnx {
  gap: 5px !important;
}

.InfoCard-module__gap-6___GSJPY {
  gap: 6px !important;
}

.InfoCard-module__gap-8___eSc79 {
  gap: 8px !important;
}

.InfoCard-module__gap-10___tZ4Ke {
  gap: 10px !important;
}

.InfoCard-module__gap-12___uvrZ2 {
  gap: 12px !important;
}

.InfoCard-module__gap-14___Pxdjw {
  gap: 14px !important;
}

.InfoCard-module__gap-16___BY_8P {
  gap: 16px !important;
}

.InfoCard-module__gap-18___qW1i4 {
  gap: 18px !important;
}

.InfoCard-module__gap-20___XW6E_ {
  gap: 20px !important;
}

.InfoCard-module__gap-24___JDCFe {
  gap: 24px !important;
}

.InfoCard-module__gap-26___i9zlw {
  gap: 26px !important;
}

.InfoCard-module__gap-30___Lvwvy {
  gap: 30px !important;
}

.InfoCard-module__gap-32___pbvp9 {
  gap: 32px !important;
}

.InfoCard-module__gap-40___Kp6eO {
  gap: 40px !important;
}

.InfoCard-module__gap-50___pd7be {
  gap: 50px !important;
}

.InfoCard-module__flex-1___TCV_0 {
  flex: 1;
}

.InfoCard-module__flex-none___RC2qK {
  flex: none !important;
}

.InfoCard-module__flex-column___EAfWZ {
  display: flex;
  flex-direction: column !important;
}

.InfoCard-module__flex-row___yrud6 {
  display: flex;
  flex-direction: row !important;
}

.InfoCard-module__vertically-centered___u3D8A {
  display: flex;
  align-items: center !important;
}

.InfoCard-module__horizontally-centered___iMFr2 {
  display: flex;
  justify-content: center !important;
}

.InfoCard-module__horizontally-end___fKAHi {
  display: flex;
  justify-content: end !important;
}

.InfoCard-module__vertically-start___xo0h1 {
  display: flex;
  align-items: start !important;
}

.InfoCard-module__space-between___MLo1G {
  display: flex;
  justify-content: space-between !important;
}

.InfoCard-module__flex-wrap___bbopJ {
  flex-wrap: wrap !important;
}

.InfoCard-module__height-100___FkkJZ {
  height: 100%;
}

.InfoCard-module__width-50___zqhuT {
  width: 50% !important;
}

.InfoCard-module__width-100___obpuc {
  width: 100%;
}

.InfoCard-module__cursor-pointer___Pjw69 {
  cursor: pointer;
}

.InfoCard-module__cursor-not-allowed___p38Zn {
  cursor: not-allowed !important;
}

.InfoCard-module__absolute-centered___rpCaA {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.InfoCard-module__absolute___F1tsi {
  position: absolute;
}

.InfoCard-module__relative___bW9Qg {
  position: relative;
}

.InfoCard-module__fixed___part_ {
  position: fixed;
}

.InfoCard-module__visible___G_YVT {
  opacity: 1;
}

.InfoCard-module__invisible___s6i9v {
  opacity: 0;
}

.InfoCard-module__col-90___hYTak {
  width: 90% !important;
}

.InfoCard-module__col-auto___xYtZu {
  width: auto !important;
}

.InfoCard-module__medical-tabs___KJzIB {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.InfoCard-module__medical-table-new___O4zFH {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.InfoCard-module__medical-table-new___O4zFH:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.InfoCard-module__medical-table-new___O4zFH::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.InfoCard-module__medical-table-new___O4zFH::-webkit-scrollbar-track {
  display: none;
}
.InfoCard-module__medical-table-new___O4zFH.InfoCard-module__no-pagination___g0lqh {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.InfoCard-module__medical-table-new___O4zFH.InfoCard-module__no-pagination___g0lqh:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.InfoCard-module__medical-table-new___O4zFH.InfoCard-module__no-pagination___g0lqh::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.InfoCard-module__medical-table-new___O4zFH.InfoCard-module__no-pagination___g0lqh::-webkit-scrollbar-track {
  display: none;
}

.InfoCard-module__medical-table-empty___UXBhP {
  padding: 14px 40px !important;
}

.InfoCard-module__icon-btn___xBzI2 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.InfoCard-module__search-icon___pQGon {
  width: 24px;
  height: 24px;
  align-self: center;
}

.InfoCard-module__disable-select___nBBtA {
  user-select: none;
}

.InfoCard-module__break-word___xmzui {
  word-break: break-word;
}

.InfoCard-module__popup-clear-btn___Y97Hs {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.InfoCard-module__scroll-m-b-20___KIbdp {
  scroll-margin-bottom: 20px;
}

.InfoCard-module__container___Uiz8_ {
  background-color: #fdfcfa;
  border-radius: 12px;
}
.InfoCard-module__container___Uiz8_ .InfoCard-module__wrapper___t669J {
  flex: 1;
  padding: 12px 48px 12px 16px;
}
.InfoCard-module__container___Uiz8_ .InfoCard-module__wrapper___t669J .InfoCard-module__title___lY_WU {
  color: #a79988;
}
.InfoCard-module__container___Uiz8_ .InfoCard-module__wrapper___t669J .InfoCard-module__content___pprf2 {
  color: #375844;
}
.InfoCard-module__container___Uiz8_ .InfoCard-module__wrapper___t669J .InfoCard-module__subtitle___vaJNq {
  color: #859989;
}
.InfoCard-module__container___Uiz8_ .InfoCard-module__wrapper___t669J .InfoCard-module__date___yAF09 {
  color: #637768;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/elements/InfoCard/InfoCard.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,mBAAA;AA8pBF;AA5pBE;EACE,OAAA;EACA,4BAAA;AA8pBJ;AA5pBI;EACE,cAAA;AA8pBN;AA3pBI;EACE,cAAA;AA6pBN;AA1pBI;EACE,cAAA;AA4pBN;AAzpBI;EACE,cAAA;AA2pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  background-color: get-color(grayNew, ultra-light);\n  border-radius: 12px;\n\n  .wrapper {\n    flex: 1;\n    padding: 12px 48px 12px 16px;\n\n    .title {\n      color: get-color(orangeNew, medium-dark);\n    }\n\n    .content {\n      color: get-color(greenNew, dark);\n    }\n\n    .subtitle {\n      color: get-color(greenNew, medium);\n    }\n\n    .date {\n      color: get-color(greenNew, medium-dark);\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `InfoCard-module__font-s-10___IE2pT`,
	"fontS12": `InfoCard-module__font-s-12___UChaW`,
	"fontS13": `InfoCard-module__font-s-13___IdVlQ`,
	"fontS14": `InfoCard-module__font-s-14___jdVUT`,
	"fontS15": `InfoCard-module__font-s-15___dHQZq`,
	"fontS16": `InfoCard-module__font-s-16___IPMN5`,
	"fontS18": `InfoCard-module__font-s-18___eF2N7`,
	"fontS20": `InfoCard-module__font-s-20___WGp7d`,
	"fontS22": `InfoCard-module__font-s-22___Kfdqo`,
	"fontS28": `InfoCard-module__font-s-28___n2kkT`,
	"fontW400": `InfoCard-module__font-w-400___D53Z6`,
	"fontW500": `InfoCard-module__font-w-500___RJPkg`,
	"fontW600": `InfoCard-module__font-w-600___GauWv`,
	"fontW700": `InfoCard-module__font-w-700___iWSez`,
	"p5": `InfoCard-module__p-5___hLebZ`,
	"p12": `InfoCard-module__p-12___BHsqd`,
	"p16": `InfoCard-module__p-16___IcNvH`,
	"p30": `InfoCard-module__p-30____W9Ym`,
	"pB0": `InfoCard-module__p-b-0___m9vgz`,
	"pB5": `InfoCard-module__p-b-5___dRORK`,
	"pB10": `InfoCard-module__p-b-10___kdQm6`,
	"pB12": `InfoCard-module__p-b-12___a20bZ`,
	"pB16": `InfoCard-module__p-b-16___eqp8K`,
	"pB18": `InfoCard-module__p-b-18___Tc78I`,
	"pB20": `InfoCard-module__p-b-20___l1iSf`,
	"pB25": `InfoCard-module__p-b-25___WAxYL`,
	"pB30": `InfoCard-module__p-b-30___SkVpa`,
	"pB50": `InfoCard-module__p-b-50___WJaUX`,
	"pT0": `InfoCard-module__p-t-0___RoP6b`,
	"pT12": `InfoCard-module__p-t-12___rIesp`,
	"pT16": `InfoCard-module__p-t-16___BJzN2`,
	"pT18": `InfoCard-module__p-t-18___yjLuU`,
	"pT20": `InfoCard-module__p-t-20___pflb5`,
	"pT30": `InfoCard-module__p-t-30___FiiBp`,
	"pT40": `InfoCard-module__p-t-40___nidgQ`,
	"pT50": `InfoCard-module__p-t-50___i7LMD`,
	"pL20": `InfoCard-module__p-l-20___A4ySy`,
	"pL30": `InfoCard-module__p-l-30___bJUI6`,
	"pL40": `InfoCard-module__p-l-40___rlXdI`,
	"pR16": `InfoCard-module__p-r-16___v6CZm`,
	"pR20": `InfoCard-module__p-r-20___rqS4J`,
	"pR30": `InfoCard-module__p-r-30___OoXr8`,
	"pR50": `InfoCard-module__p-r-50___ukmf2`,
	"pR60": `InfoCard-module__p-r-60___FGw32`,
	"mB1": `InfoCard-module__m-b-1___nvVGt`,
	"mB2": `InfoCard-module__m-b-2___UzLQO`,
	"mB6": `InfoCard-module__m-b-6___YgEE8`,
	"mB8": `InfoCard-module__m-b-8___W2mjM`,
	"mB10": `InfoCard-module__m-b-10___Xy1QJ`,
	"mB14": `InfoCard-module__m-b-14___nuprn`,
	"mB16": `InfoCard-module__m-b-16___CYxXt`,
	"mB20": `InfoCard-module__m-b-20___adgeR`,
	"mB22": `InfoCard-module__m-b-22___hS1J5`,
	"mB24": `InfoCard-module__m-b-24___rHMuM`,
	"mB30": `InfoCard-module__m-b-30___hAjev`,
	"mB32": `InfoCard-module__m-b-32___Wk28N`,
	"mB40": `InfoCard-module__m-b-40___uTHku`,
	"mT2": `InfoCard-module__m-t-2___Uzsv3`,
	"mT3": `InfoCard-module__m-t-3___iPmeP`,
	"mT4": `InfoCard-module__m-t-4___dF2pX`,
	"mT5": `InfoCard-module__m-t-5___VcWaw`,
	"mT8": `InfoCard-module__m-t-8___XmW1D`,
	"mT10": `InfoCard-module__m-t-10___mI0wd`,
	"mT15": `InfoCard-module__m-t-15___G7810`,
	"mT16": `InfoCard-module__m-t-16___KM8f_`,
	"mT20": `InfoCard-module__m-t-20___KZQ7I`,
	"mT22": `InfoCard-module__m-t-22___IqKPt`,
	"mT30": `InfoCard-module__m-t-30___yfEl8`,
	"mT32": `InfoCard-module__m-t-32___pvCSu`,
	"mLAuto": `InfoCard-module__m-l-auto___hEPay`,
	"mL4": `InfoCard-module__m-l-4___cqBYF`,
	"mL5": `InfoCard-module__m-l-5___hHoXh`,
	"mL6": `InfoCard-module__m-l-6___h0NMV`,
	"mL8": `InfoCard-module__m-l-8___mq7HD`,
	"mL10": `InfoCard-module__m-l-10___qtA97`,
	"mL16": `InfoCard-module__m-l-16___iylwY`,
	"mL20": `InfoCard-module__m-l-20___q4yT8`,
	"mL24": `InfoCard-module__m-l-24___YgQbr`,
	"mL30": `InfoCard-module__m-l-30___NI5jV`,
	"mL35": `InfoCard-module__m-l-35___HYo8c`,
	"mL40": `InfoCard-module__m-l-40___RKQBL`,
	"mR8": `InfoCard-module__m-r-8___Qxspx`,
	"mR10": `InfoCard-module__m-r-10___M824N`,
	"mR16": `InfoCard-module__m-r-16___Z8zLw`,
	"mR20": `InfoCard-module__m-r-20___kJJx_`,
	"mR24": `InfoCard-module__m-r-24___nFr1S`,
	"mR30": `InfoCard-module__m-r-30___LK9x3`,
	"mR40": `InfoCard-module__m-r-40___bZaUC`,
	"borderR3": `InfoCard-module__border-r-3___GJtg3`,
	"borderR4": `InfoCard-module__border-r-4___wvowk`,
	"borderR6": `InfoCard-module__border-r-6___Yfa0a`,
	"borderR10": `InfoCard-module__border-r-10___HZ9Kv`,
	"borderR12": `InfoCard-module__border-r-12___VHwqe`,
	"borderR16": `InfoCard-module__border-r-16___LkFnc`,
	"borderR50": `InfoCard-module__border-r-50___lDtQu`,
	"primaryBorder": `InfoCard-module__primary-border___ru61z`,
	"primaryBorderB": `InfoCard-module__primary-border-b___UEa7e`,
	"primaryBorderT": `InfoCard-module__primary-border-t___RCnI6`,
	"primaryBorderL": `InfoCard-module__primary-border-l___Y9xMX`,
	"primaryBorderR": `InfoCard-module__primary-border-r___KdZfj`,
	"secondaryBorder": `InfoCard-module__secondary-border___AayhP`,
	"secondaryBorderB": `InfoCard-module__secondary-border-b___fMkEj`,
	"secondaryBorderT": `InfoCard-module__secondary-border-t___nFnwY`,
	"secondaryBorderL": `InfoCard-module__secondary-border-l___Y_deX`,
	"secondaryBorderR": `InfoCard-module__secondary-border-r___JO99N`,
	"gap0": `InfoCard-module__gap-0___F0i9N`,
	"gap2": `InfoCard-module__gap-2___VhWNx`,
	"gap4": `InfoCard-module__gap-4____oMFe`,
	"gap5": `InfoCard-module__gap-5___KuMnx`,
	"gap6": `InfoCard-module__gap-6___GSJPY`,
	"gap8": `InfoCard-module__gap-8___eSc79`,
	"gap10": `InfoCard-module__gap-10___tZ4Ke`,
	"gap12": `InfoCard-module__gap-12___uvrZ2`,
	"gap14": `InfoCard-module__gap-14___Pxdjw`,
	"gap16": `InfoCard-module__gap-16___BY_8P`,
	"gap18": `InfoCard-module__gap-18___qW1i4`,
	"gap20": `InfoCard-module__gap-20___XW6E_`,
	"gap24": `InfoCard-module__gap-24___JDCFe`,
	"gap26": `InfoCard-module__gap-26___i9zlw`,
	"gap30": `InfoCard-module__gap-30___Lvwvy`,
	"gap32": `InfoCard-module__gap-32___pbvp9`,
	"gap40": `InfoCard-module__gap-40___Kp6eO`,
	"gap50": `InfoCard-module__gap-50___pd7be`,
	"flex1": `InfoCard-module__flex-1___TCV_0`,
	"flexNone": `InfoCard-module__flex-none___RC2qK`,
	"flexColumn": `InfoCard-module__flex-column___EAfWZ`,
	"flexRow": `InfoCard-module__flex-row___yrud6`,
	"verticallyCentered": `InfoCard-module__vertically-centered___u3D8A`,
	"horizontallyCentered": `InfoCard-module__horizontally-centered___iMFr2`,
	"horizontallyEnd": `InfoCard-module__horizontally-end___fKAHi`,
	"verticallyStart": `InfoCard-module__vertically-start___xo0h1`,
	"spaceBetween": `InfoCard-module__space-between___MLo1G`,
	"flexWrap": `InfoCard-module__flex-wrap___bbopJ`,
	"height100": `InfoCard-module__height-100___FkkJZ`,
	"width50": `InfoCard-module__width-50___zqhuT`,
	"width100": `InfoCard-module__width-100___obpuc`,
	"cursorPointer": `InfoCard-module__cursor-pointer___Pjw69`,
	"cursorNotAllowed": `InfoCard-module__cursor-not-allowed___p38Zn`,
	"absoluteCentered": `InfoCard-module__absolute-centered___rpCaA`,
	"absolute": `InfoCard-module__absolute___F1tsi`,
	"relative": `InfoCard-module__relative___bW9Qg`,
	"fixed": `InfoCard-module__fixed___part_`,
	"visible": `InfoCard-module__visible___G_YVT`,
	"invisible": `InfoCard-module__invisible___s6i9v`,
	"col90": `InfoCard-module__col-90___hYTak`,
	"colAuto": `InfoCard-module__col-auto___xYtZu`,
	"medicalTabs": `InfoCard-module__medical-tabs___KJzIB`,
	"medicalTableNew": `InfoCard-module__medical-table-new___O4zFH`,
	"noPagination": `InfoCard-module__no-pagination___g0lqh`,
	"medicalTableEmpty": `InfoCard-module__medical-table-empty___UXBhP`,
	"iconBtn": `InfoCard-module__icon-btn___xBzI2`,
	"searchIcon": `InfoCard-module__search-icon___pQGon`,
	"disableSelect": `InfoCard-module__disable-select___nBBtA`,
	"breakWord": `InfoCard-module__break-word___xmzui`,
	"popupClearBtn": `InfoCard-module__popup-clear-btn___Y97Hs`,
	"scrollMB20": `InfoCard-module__scroll-m-b-20___KIbdp`,
	"container": `InfoCard-module__container___Uiz8_`,
	"wrapper": `InfoCard-module__wrapper___t669J`,
	"title": `InfoCard-module__title___lY_WU`,
	"content": `InfoCard-module__content___pprf2`,
	"subtitle": `InfoCard-module__subtitle___vaJNq`,
	"date": `InfoCard-module__date___yAF09`
};
module.exports = ___CSS_LOADER_EXPORT___;
